import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

type CardMessageProps = {
  icon: JSX.Element;
  style?: React.CSSProperties;
  message: string;
  cardMessageContainerHeight?: string;
};

const CardMessage = ({
  icon,
  message,
  style,
  cardMessageContainerHeight,
}: CardMessageProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      cardMessageContainer: {
        height: cardMessageContainerHeight
          ? cardMessageContainerHeight
          : '100%',
        padding: theme.spacing(2),
      },
    }),
  );

  const classes = useStyles();
  return (
    <Grid
      container
      alignItems="center"
      className={classes.cardMessageContainer}
      style={style}
    >
      <Grid item xs={12}>
        <Typography color="textSecondary" align="center" variant="h6">
          {icon}
          <br />
          {message}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CardMessage;
